import { formatToMilliseconds } from 'utils';

import { TConfig } from 'types';

declare global {
  interface Window {
    RUNTIME_CONFIG?: {
      VITE_REACT_APP_ENV_VAR?: string;
      AUTH_DOMAIN?: string;
    };
  }
}

const getEnv = () => {
  // Debug logging
  console.log('Window runtime config:', window.RUNTIME_CONFIG);
  // check runtime config
  if (window.RUNTIME_CONFIG?.VITE_REACT_APP_ENV_VAR) {
    // eslint-disable-next-line no-console
    console.log('Using environment from RUNTIME_CONFIG:', window.RUNTIME_CONFIG.VITE_REACT_APP_ENV_VAR);
    return window.RUNTIME_CONFIG.VITE_REACT_APP_ENV_VAR;
  }
  console.log('No Runtime config found, using fallback');
  console.log('Build-time env var:', import.meta.env.VITE_REACT_APP_ENV_VAR);

  // fallback to build-time env
  return import.meta.env.VITE_REACT_APP_ENV_VAR || 'dev';
};

const ENV = getEnv() as 'dev' | 'int' | 'uat' | 'prod';

export const config = {
  dev: {
    SSOURL: 'https://dev.adminportal.airmiles.ca/snap',
    apiURL: 'https://dashboard.dev.snapportal.airmiles.ca/admin',
    adminURL: 'https://dev.adminportal.airmiles.ca/api',
    auth0Domain: 'auth.dev.airmiles.ai',
    auth0ClientId: '7P4qfuPRoNKPNUDEm6MWfKcB16x7swWd',
    inactiveTimeout: formatToMilliseconds(8, 'hours'),
  },
  int: {
    SSOURL: 'https://int.adminportal.airmiles.ca/snap',
    apiURL: 'https://dashboard.int.snapportal.airmiles.ca/admin',
    adminURL: 'https://int.adminportal.airmiles.ca/api',
    auth0Domain: 'auth.dev.airmiles.ai',
    auth0ClientId: '7P4qfuPRoNKPNUDEm6MWfKcB16x7swWd',
    inactiveTimeout: formatToMilliseconds(8, 'hours'),
  },
  uat: {
    SSOURL: 'https://uat.adminportal.airmiles.ca/snap',
    apiURL: 'https://dashboard.uat.snapportal.airmiles.ca/admin',
    adminURL: 'https://uat.adminportal.airmiles.ca/api',
    auth0Domain: 'auth.uat.airmiles.ai',
    auth0ClientId: 'GRNyNndNnI8cz650CLj5miZ7KU3gqc5i',
    inactiveTimeout: formatToMilliseconds(15),
  },
  prod: {
    SSOURL: 'https://adminportal.airmiles.ca/snap',
    apiURL: 'https://dashboard.snapportal.airmiles.ca/admin',
    adminURL: 'https://adminportal.airmiles.ca/api',
    auth0Domain: 'auth.airmiles.ai',
    auth0ClientId: 'Wv2DmguXyFEt62Py4O96o8z2UvHkosIJ',
    inactiveTimeout: formatToMilliseconds(15),
  },
}[ENV] as TConfig;
